'use strict';

import NotificationBar from '../NotificationBar/NotificationBar';
import template from './templates/_PromotionalGiveawayNotificationBar.hbs';

export default class PromotionalGiveawayNotificationBar extends NotificationBar {
  initialize() {
    this.template = template;
  }

  displayNotification() {
    this.show(this.model);
  }
}

export function createPromotionalGiveawayNotificationBar($notificationBar, data) {
  if ($notificationBar.length) {
    let bar = new PromotionalGiveawayNotificationBar({ el: $notificationBar, model: data });
    bar.displayNotification();
  }
}



// WEBPACK FOOTER //
// ./assets/components/PromotionalGiveaway/PromotionalGiveawayNotificationBar.js